// Module
var code = "<div uib-dropdown> <a href uib-dropdown-toggle translate=\"{{ vm.currentTab }}\"> </a> <ul class=dropdown-menu uib-dropdown-menu> <li ng-repeat=\"tab in vm.tabs\" ng-if=\"tab !== vm.currentTab\"> <a href ng-click=vm.handleOnChange(tab) translate=\"{{ tab }}\"> </a> </li> </ul> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/common/ui/actionTabs/templates/actionTabs.vertical-dropdown.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;